var currentSuggetionInputId = "";

export default function initSubjectLinePicker(swrapper, canvasService, translate, selectCallBack) {
    function renderNoSuggestionMessage() {
        return "<div class='subject-line-no-container'>" +
            "	<div class='subject-line-no-image'></div>" +
            "	<div class='subject-line-no-message'>" +
            " 		<h2>" + translate('canvas.suggestions.no') + "</h2>" +
            "		<p class='subject-line-no-message-text'>" + translate('canvas.suggestions.no.data') + "</p>" +
            "	</div>" +
            "</div>"
    }

    function renderSubjectLineSuggestion(suggestion) {
        return "<li class='subject-line-picker-row'>" +
            "<div class='subject-line-row-icons'>" +
            "<span class='subject-line-increase-icon'></span>" +
            "<span class='subject-line-status status active'>" + Math.round(suggestion.OpenAverage) + "% " + translate('canvas.suggestions.open') + "</span>" +
            "</div>" +
            "<span class='subject-line-picker-text'>" + suggestion.EmailName + "</span>" +
            "</li>";
    }

    function renderSubjectLineSuggestionList(items) {
        var resultHtml = "<div class='subject-line-header'>" + translate('canvas.suggestions.top') + "</div>" +
            "<ul class='subject-line-list'>";

        var defaultItemCount = 20;

        for(var i = 0; i < Math.min(items.length, defaultItemCount); i++) {
            resultHtml += renderSubjectLineSuggestion(items[i]);
        }

        if (items.length > defaultItemCount) {
            resultHtml += "<div class='subject-line-extra-items' style='display: none;'>"
            for(var i = defaultItemCount; i < items.length; i++) {
                resultHtml += renderSubjectLineSuggestion(items[i]);
            }
            resultHtml += "</div>"
        }
        return resultHtml;
    }

    function normalizeWidth() {
        var maxWidth = 0;
        $(".subject-line-row-icons").each(function (i, item) {
            maxWidth = $(item).width() > maxWidth ? $(item).width() : maxWidth;
        });

        $(".subject-line-row-icons").each(function (i, item) {
            $(item).css('width', Math.ceil(maxWidth) + 'px');
        });
    }

    function setContainerPosition(input, container) {
        var inputRect = input.getBoundingClientRect();
        container.css({
            top: '45x',
            left: 0,
            width: Math.ceil(inputRect.width) + 1 + 'px',
            'z-index': 999999,
            height: '270px',
            overflow: 'auto'
        });
        container.slideDown(400);
        normalizeWidth();
    }

    function setSubjectLine(input, sender) {
        var subjectLine = "";
        if (sender.hasClass('subject-line-picker-text')) {
            subjectLine = sender.text();
        }

        if (sender.hasClass('subject-line-picker-row')) {
            var textContainer = sender.find('.subject-line-picker-text');
            subjectLine = textContainer.text();
        }

        if (sender.hasClass('subject-line-status') ||
            sender.hasClass('subject-line-increase-icon') ||
            sender.hasClass('subject-line-row-icons')) {
            var textContainer = sender.closest('.subject-line-picker-row').find('.subject-line-picker-text');
            subjectLine = textContainer.text();
        }

        selectCallBack(subjectLine);
        setTimeout(() => { document.getElementById(currentSuggetionInputId).click(); }, 300);
    }

    function closeSubjectLinePicker(container) {
        container.slideUp(400);
        $('.subject-line-picker').each(function(i, item) {
            $(item).removeClass('is-active');
        });
    }

    function recognizeFooter(sender) {
        return sender.hasClass('subject-line-footer-link')
    }

    function recognizeRow(sender) {
        return  sender.hasClass('subject-line-picker-row') ||
            sender.hasClass('subject-line-picker-text') ||
            sender.hasClass('subject-line-status') ||
            sender.hasClass('subject-line-row-icons') ||
            sender.hasClass('subject-line-increase-icon')
    }

    function recognizeNoMessage(sender) {
        return  sender.hasClass('subject-line-no-container') ||
            sender.hasClass('subject-line-no-image') ||
            sender.hasClass('subject-line-no-message') ||
            sender.hasClass('subject-line-no-mobile') ||
            sender.hasClass('subject-line-no-message-text')
    }

    function recognizePicker(sender) {
        return  sender.hasClass('subject-line-picker') ||
            recognizeRow(sender) ||
            recognizeFooter(sender) ||
            recognizeNoMessage(sender)
    }

    $(window).on('resize', function () {
        if (!currentSuggetionInputId) {
            return;
        }

        var input = $('#' + currentSuggetionInputId)[0];
        var container = $(`.${swrapper}`);
        setContainerPosition(input, container);
    });

    $(document).on('click touchend', function (event) {
        event.stopPropagation();

        var sender = $(event.target);
        if (sender.hasClass('disabled') || sender.attr('disabled')) {
            return;
        }

        var container = $(`.${swrapper}`);
        if (!recognizePicker(sender))
        {
            closeSubjectLinePicker(container);
            currentSuggetionInputId = null;
            return;
        }

        if (sender.hasClass('subject-line-picker')) {
            var inputId = event.target.dataset.for;

            if (!inputId) {
                return;
            }
            currentSuggetionInputId = inputId;

            var input = document.getElementById(inputId)
            setContainerPosition(input, container);
            sender.addClass('is-active');

        }

        if (recognizeRow(sender)) {
            var input = $('#' + currentSuggetionInputId)[0];
            setSubjectLine(input, sender);
            closeSubjectLinePicker(container);
        }

        if (sender.hasClass('subject-line-footer-link')) {
            var extraContainer = container.find('.subject-line-extra-items');
            if (!extraContainer) {
                return;
            }

            if (sender.hasClass("open") ) {
                sender.removeClass("open")
                extraContainer.slideUp(400);
            } else {
                extraContainer.slideDown(400);
                sender.addClass("open")
            }

            normalizeWidth();
        }
    });

    // initialize suggestions
    canvasService.getSubjectLine().then(({data}) => {
        if (data.SubjectLines.length === 0) {
            $(`.${swrapper}`).html(renderNoSuggestionMessage());
        } else {
            var truncatedData = data.SubjectLines.slice(0, 10);
            $(`.${swrapper}`).html(renderSubjectLineSuggestionList(truncatedData));
        }
    });
}



// WEBPACK FOOTER //
// ./app/utils/subject-line-picker.js